<template>
  <div>
    <i-select :filterable="true" :clearable="clearable" :value="value" @input="input">
      <i-option v-for="i in list" :key="i.id" :value="i.id" :label="i.name" />
    </i-select>
  </div>
</template>

<script>
  import { CampaignsService } from '@autocaller_v2/services/CampaignsService';

  export default {
    props: {
      only_active: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      value: {
        type: [String, Number],
        default: ''
      },
    },
    data: () => ({
      list: []
    }),
    created() {
      const params = {
        active: this.only_active ? 1 : undefined
      };
      CampaignsService.getCampaignSelect(params).then((response) => {
        if (this.only_active) {
          this.list = response.sort(function (a, b) {
            return a.updated_at > b.updated_at ? -1 : a.updated_at < b.updated_at ? 1 : 0;
          });
          this.$emit('input', this.list[0]?.id);
        } else {
          this.list = response;
        }
      });
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
